import ROLES from '@/utils/roles';
import TOP_BARS from '@/utils/topBars';
import FOOTERS from '@/utils/footers';
let routes = [
  {
    path: '/wecom/oauth/entry',
    name: 'wecom-oauth-entry',
    component: () => import('@/views/WeCom/Oauth/Entry'),
    meta: {
      topBar: TOP_BARS.NULL
    }
  },
  {
    path: '/wecom/oauth/middle',
    name: 'wecom-oauth-middle',
    component: () => import('@/views/WeCom/Oauth/Middle'),
    meta: {
      topBar: TOP_BARS.NULL
    }
  },
  {
    path: '/wecom/oauth/success',
    name: 'wecom-oauth-success',
    component: () => import('@/views/WeCom/Oauth/Success')
  },
  {
    path: '/wecom/oauth/fail/:type?',
    name: 'wecom-oauth-fail',
    component: () => import('@/views/WeCom/Oauth/Fail')
  },
  {
    path: '/wecom/seminar/divide',
    name: 'wecom-seminar-divide',
    component: () => import('@/views/WeCom/Seminar/Divide'),
    meta: {
      topBar: TOP_BARS.NULL
    }
  },
  {
    path: '/wecom/seminar/middle/:type/:userId',
    name: 'wecom-seminar-middle',
    component: () => import('@/views/WeCom/Seminar/Middle'),
    meta: {
      topBar: TOP_BARS.NULL
    }
  },
  {
    path: '/wecom/seminar/add/:userId/:type?',
    name: 'wecom-seminar-add',
    component: () => import('@/views/WeCom/Seminar/Add'),
    meta: {
      topBar: TOP_BARS.NULL
    }
  },
  {
    path: '/wecom/seminar/error/:type/:userId?',
    name: 'wecom-seminar-error',
    component: () => import('@/views/WeCom/Seminar/Error'),
    meta: {
      topBar: TOP_BARS.NULL
    }
  },
  {
    path: '/wecom/seminar',
    name: 'wecom-seminar',
    component: () => import('@/views/WeCom/Seminar/Entry'),
    meta: {
      topBar: TOP_BARS.NULL
    }
  }
];
routes = routes.map(item => {
  let ret = Object.assign({}, item);
  ret.meta = Object.assign(
    {},
    {
      role: ROLES.STUDENT,
      footer: FOOTERS.NULL
    },
    ret.meta
  );
  return ret;
});
export default routes;
